import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "app-file-upload",
  templateUrl: "./file-upload.component.html",
  styleUrls: ["./file-upload.component.scss"],
})
export class FileUploadComponent {
  @ViewChild("fileInput") fileInput: ElementRef;
  @Input() disabled = false;
  @Input() acceptedFileTypes = "csv";
  @Input() allowMultiple = false;
  @Input() centerField = false;
  @Input() content = "";
  @Output() uploaded = new EventEmitter<File[]>();

  files: File[] = [];

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.files = Array.from(input.files);
      this.uploaded.emit(this.files);
    }
  }

  onFileDropped(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files.length) {
      this.files = Array.from(event.dataTransfer.files);
      this.uploaded.emit(this.files);
    }
  }

  onDragOver(event: Event) {
    event.preventDefault();
  }

  onDragLeave(event: Event) {
    event.preventDefault();
  }

  clearFiles(event: Event) {
    event.preventDefault();
    event.stopPropagation()
    this.files = [];
    this.uploaded.emit(this.files);
  }
}
